const inBrowser = typeof window !== "undefined" && window.location;

const isDocker =
  process.env.REACT_APP_ENVIRONMENT === "docker-local" ||
  process.env.REACT_APP_DOCKER === "true" ||
  (typeof process !== "undefined" &&
    process.env &&
    process.env.DOCKER === "true");

const buildLocalhostUrl = (apiHostname, port) => {
  const h = (apiHostname || "http://localhost").replace(/\/$/, "");
  const p = String(port || "");
  try {
    const u = new URL(h);
    if (!u.port) u.port = p;
    return u.toString().replace(/\/$/, "");
  } catch {
    return `${h}:${p}`;
  }
};

const dockerServiceUrls = () => ({
  BACKEND_API_URL:
    process.env.REACT_APP_BACKEND_API_DOCKER_HOSTNAME || "http://backend:3000",
  FRONTEND_APP_URL:
    process.env.REACT_APP_API_DOCKER_HOSTNAME || "http://frontend:9090",
});

const hostMatchUrls = (hostname) => {
  const root = `http://${hostname}`;
  const bp = process.env.REACT_APP_API_BACKEND_PORT || "3000";
  const fp = process.env.REACT_APP_API_FRONTEND_PORT || "9090";
  return {
    BACKEND_API_URL: buildLocalhostUrl(root, bp),
    FRONTEND_APP_URL: buildLocalhostUrl(root, fp),
  };
};

let BACKEND_API_URL;
let FRONTEND_APP_URL;

if (isDocker) {
  if (inBrowser) {
    if (window.location.hostname === "frontend") {
      const s = dockerServiceUrls();
      BACKEND_API_URL = s.BACKEND_API_URL;
      FRONTEND_APP_URL = s.FRONTEND_APP_URL;
    } else {
      const s = hostMatchUrls(window.location.hostname);
      BACKEND_API_URL = s.BACKEND_API_URL;
      FRONTEND_APP_URL = s.FRONTEND_APP_URL;
    }
  } else {
    const s = dockerServiceUrls();
    BACKEND_API_URL = s.BACKEND_API_URL;
    FRONTEND_APP_URL = s.FRONTEND_APP_URL;
  }
} else if ((process.env.REACT_APP_API_HOSTNAME || "").includes("localhost") ||
  (process.env.REACT_APP_API_HOSTNAME || "").includes("127.0.0.1")) {
  const h = process.env.REACT_APP_API_HOSTNAME;
  const bp = process.env.REACT_APP_API_BACKEND_PORT || "3000";
  const fp = process.env.REACT_APP_API_FRONTEND_PORT || "9090";
  const base = h && h.startsWith("http")
    ? h
    : `http://${(h || "localhost").replace(/^https?:\/\//, "")}`;
  BACKEND_API_URL = buildLocalhostUrl(base, bp);
  FRONTEND_APP_URL = buildLocalhostUrl(base, fp);
} else {
  BACKEND_API_URL = `${process.env.REACT_APP_API_HOSTNAME}/api`;
  FRONTEND_APP_URL = `${process.env.REACT_APP_API_HOSTNAME}`;
}

export { BACKEND_API_URL, FRONTEND_APP_URL, isDocker };
